import Loader from '~/components/Loading/Cards'
import Loadable from '~/utils/loadable'

export default Loadable({
  loader: () => import('./Router'),
  loading: Loader,
})
